import { render } from "./commodity.vue?vue&type=template&id=ea7a49c4"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__